module.exports = __webpack_public_path__ + "static/media/4d25be1b-1870-44f8-b6a3-16c7e1e103c2.5d4de0ce.jpeg";